export const visit = (vm, at) => {
vm(require("./availability/en-gb.lyaml"));
vm(require("./typical-response-time/en-gb.lyaml"));
vm(require("./default/en-gb.lyaml"));
at({ "en-gb": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "okay" } } });
};